import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import { createLayer } from '../../util/createLayer';

const ArcGraphicsLayer = createLayer(GraphicsLayer);

export { ArcGraphicsLayer };
